// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"765":"2e793e64","799":"ef7a513d"}[chunkId] + ".chunk.js";
};